module.exports = __webpack_public_path__ + "img/car_00054.c23ac34d.jpg";